import { FilePdfOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
import { IPayloadApproveTum } from 'app/api/newTumRegister/model'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { useApproveTum } from 'app/react-query/hook/newTumRegister'
import { handleDownloadFile } from 'app/service/general/service'
import { useRef } from 'react'
import { ENewTumRegisterStatus } from '../../type'

interface IProps {
  name?: string
  id?: string
  file?: string
  fileName?: string
}

export const RejectTumModal = ({ name, id, file, fileName }: IProps) => {
  const modalRef = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<IPayloadApproveTum>()

  const { mutateAsync: mutateAsyncApprove, isLoading } = useApproveTum()

  const onSubmit = async (values: IPayloadApproveTum) => {
    if (!id || !values?.reason) {
      return
    }

    try {
      await mutateAsyncApprove({
        id: parseInt(id),
        status: ENewTumRegisterStatus.REJECTED,
        reason: values?.reason,
      })
      modalRef.current?.hide?.()
    } catch (error) {
      console.log('Error:', error)
    }
  }

  const onClickDownloadFile = async () => {
    if (fileName && file) {
      await handleDownloadFile({
        fileName,
        fileUrl: file,
        // actionSuccess: () => {
        //   notificationController.success({ message: 'Đã tải xuống!' })
        // },
      })
    }
  }

  return (
    <BaseModalComponent
      titleModal={'Xác nhận'}
      titleOpenModal="Từ chối"
      widthModal={400}
      ref={modalRef}
      handleSubmit={form.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={onSubmit}>
          <BaseSpace size={8}>
            <BaseRow gutter={8} align={'middle'} justify={'center'}>
              <BaseCol>
                <BaseText fontWeight="medium" fontSize="xs">
                  {'Bạn có thực sự muốn từ chối đoàn viên?'}
                </BaseText>
              </BaseCol>
              <BaseCol>
                <BaseText
                  children={`"${name ?? ''}"`}
                  colorText="statesRedColor"
                  fontWeight="medium"
                  fontSize="xs"
                />
              </BaseCol>
            </BaseRow>

            <BaseText children={'Lý do từ chối'} fontWeight="medium" />
            <BaseForm.Item
              hiddenLabel
              style={{ marginBottom: 0 }}
              name={'reason'}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập lý do từ chối',
                },
              ]}
            >
              <TextArea placeholder="Vui lòng nhập lý do từ chối" />
            </BaseForm.Item>

            <BaseRow
              gutter={6}
              align={'middle'}
              style={{ cursor: 'pointer' }}
              onClick={onClickDownloadFile}
              justify={'start'}
            >
              <BaseCol>
                <FilePdfOutlined rev={undefined} />
              </BaseCol>
              <BaseCol>
                <BaseText
                  children={fileName}
                  colorText="collapseBackgroundColor"
                  fontWeight="medium"
                />
              </BaseCol>
            </BaseRow>
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
